import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=d2c0cfba&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=d2c0cfba&lang=scss&scoped=true&"
import style1 from "./Edit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c0cfba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2c0cfba')) {
      api.createRecord('d2c0cfba', component.options)
    } else {
      api.reload('d2c0cfba', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=d2c0cfba&scoped=true&", function () {
      api.rerender('d2c0cfba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/tenders/addendum/Edit.vue"
export default component.exports